import { render, staticRenderFns } from "./OrderProcessDialog.vue?vue&type=template&id=65dd6f16&"
import script from "./OrderProcessDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderProcessDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OrderProcessDialog.vue?vue&type=style&index=0&id=65dd6f16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports